const DEFAULT_PASSWORD_LENGTH = 12;

const PASSWORD_CHARS =
  "ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz23456789!@#$%^&*";

export const generatePassword = (length: number = DEFAULT_PASSWORD_LENGTH) => {
  let res = "";
  for (let i = 0; i < length; i += 1) {
    res += PASSWORD_CHARS[Math.floor(Math.random() * PASSWORD_CHARS.length)];
  }
  return res;
};
